import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c0ad1cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "orangehrm-background-container" }
const _hoisted_2 = { class: "orangehrm-card-container ffj-yearly-report" }
const _hoisted_3 = { class: "ffj-yearly-report__header" }
const _hoisted_4 = { class: "orangehrm-main-title" }
const _hoisted_5 = {
  key: 0,
  class: "ffj-yearly-report__loading",
  "data-testid": "ffj-yearly-report-loading"
}
const _hoisted_6 = {
  key: 1,
  class: "ffj-yearly-report__error",
  role: "alert",
  "data-testid": "ffj-yearly-report-error"
}
const _hoisted_7 = {
  key: 2,
  class: "ffj-yearly-report__grid",
  "data-testid": "ffj-yearly-report-grid"
}
const _hoisted_8 = {
  class: "ffj-yearly-report__employee-info",
  "data-testid": "ffj-yearly-report-employee-info"
}
const _hoisted_9 = { class: "ffj-yearly-report__table" }
const _hoisted_10 = { class: "ffj-yearly-report__month-col" }
const _hoisted_11 = { class: "ffj-yearly-report__stat-col" }
const _hoisted_12 = { class: "ffj-yearly-report__stat-col" }
const _hoisted_13 = ["data-testid"]
const _hoisted_14 = { class: "ffj-yearly-report__label-cell" }
const _hoisted_15 = { class: "ffj-yearly-report__stat-cell" }
const _hoisted_16 = { class: "ffj-yearly-report__totals-row" }
const _hoisted_17 = { class: "ffj-yearly-report__label-cell ffj-yearly-report__totals-label" }
const _hoisted_18 = { class: "ffj-yearly-report__stat-cell ffj-yearly-report__totals-value" }
const _hoisted_19 = {
  key: 3,
  class: "ffj-yearly-report__empty",
  "data-testid": "ffj-yearly-report-empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_divider = _resolveComponent("oxd-divider")!
  const _component_date_input = _resolveComponent("date-input")!
  const _component_oxd_grid_item = _resolveComponent("oxd-grid-item")!
  const _component_employee_autocomplete = _resolveComponent("employee-autocomplete")!
  const _component_oxd_grid = _resolveComponent("oxd-grid")!
  const _component_oxd_form_row = _resolveComponent("oxd-form-row")!
  const _component_required_text = _resolveComponent("required-text")!
  const _component_oxd_button = _resolveComponent("oxd-button")!
  const _component_oxd_form_actions = _resolveComponent("oxd-form-actions")!
  const _component_oxd_form = _resolveComponent("oxd-form")!
  const _component_oxd_table_filter = _resolveComponent("oxd-table-filter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _createElementVNode("h6", _hoisted_4, _toDisplayString(_ctx.$t('forfait_jours.yearly_report_title')), 1)
      ]),
      _createVNode(_component_oxd_divider),
      _createVNode(_component_oxd_table_filter, null, {
        default: _withCtx(() => [
          _createVNode(_component_oxd_form, {
            onSubmitValid: _ctx.onSearch,
            onReset: _ctx.onReset
          }, {
            default: _withCtx(() => [
              _createVNode(_component_oxd_form_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_oxd_grid, {
                    cols: 4,
                    class: "orangehrm-full-width-grid"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_oxd_grid_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_date_input, {
                            modelValue: _ctx.fromDate,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fromDate) = $event)),
                            label: _ctx.$t('general.from_date'),
                            rules: _ctx.rules.fromDate
                          }, null, 8, ["modelValue", "label", "rules"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_oxd_grid_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_date_input, {
                            modelValue: _ctx.toDate,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.toDate) = $event)),
                            label: _ctx.$t('general.to_date'),
                            rules: _ctx.rules.toDate
                          }, null, 8, ["modelValue", "label", "rules"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_oxd_grid_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_employee_autocomplete, {
                            modelValue: _ctx.employee,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.employee) = $event)),
                            rules: _ctx.rules.employee,
                            params: _ctx.employeeParams
                          }, null, 8, ["modelValue", "rules", "params"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_oxd_grid_item)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_oxd_divider),
              _createVNode(_component_oxd_form_actions, null, {
                default: _withCtx(() => [
                  _createVNode(_component_required_text),
                  _createVNode(_component_oxd_button, {
                    "display-type": "ghost",
                    label: _ctx.$t('general.reset'),
                    type: "reset"
                  }, null, 8, ["label"]),
                  _createVNode(_component_oxd_button, {
                    class: "orangehrm-left-space",
                    "display-type": "secondary",
                    label: _ctx.$t('general.search'),
                    type: "submit"
                  }, null, 8, ["label"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onSubmitValid", "onReset"])
        ]),
        _: 1
      }),
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t('general.loading')), 1))
        : (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.error), 1))
          : (_ctx.stats)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.stats.fullName), 1),
                  _createTextVNode(" — " + _toDisplayString(_ctx.stats.fromDate) + " – " + _toDisplayString(_ctx.stats.toDate), 1)
                ]),
                _createElementVNode("table", _hoisted_9, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t('forfait_jours.yearly_report_month_label')), 1),
                      _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t('forfait_jours.yearly_report_unrespected_rest_label')), 1),
                      _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t('forfait_jours.yearly_report_worked_days_label')), 1)
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stats.months, (month, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: index,
                        "data-testid": `ffj-yearly-report-month-row-${month.year}-${month.month}`,
                        class: "ffj-yearly-report__row"
                      }, [
                        _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.monthLabel(month.year, month.month)), 1),
                        _createElementVNode("td", {
                          class: _normalizeClass(["ffj-yearly-report__stat-cell", {
                  'ffj-yearly-report__stat-cell--warning':
                    month.unrespectedRestDays > 0,
                }])
                        }, _toDisplayString(month.unrespectedRestDays), 3),
                        _createElementVNode("td", _hoisted_15, _toDisplayString(month.workedDays), 1)
                      ], 8, _hoisted_13))
                    }), 128))
                  ]),
                  _createElementVNode("tfoot", null, [
                    _createElementVNode("tr", _hoisted_16, [
                      _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.$t('forfait_jours.yearly_report_total_label')), 1),
                      _createElementVNode("td", {
                        class: _normalizeClass(["ffj-yearly-report__stat-cell ffj-yearly-report__totals-value", {
                  'ffj-yearly-report__stat-cell--danger':
                    _ctx.stats.totalUnrespectedRestDays > 0,
                }])
                      }, _toDisplayString(_ctx.stats.totalUnrespectedRestDays), 3),
                      _createElementVNode("td", _hoisted_18, _toDisplayString(_ctx.stats.totalWorkedDays), 1)
                    ])
                  ])
                ])
              ]))
            : (!_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.$t('forfait_jours.yearly_report_search_prompt')), 1))
              : _createCommentVNode("", true)
    ])
  ]))
}